import { render, staticRenderFns } from "./SoftVersionImage.vue?vue&type=template&id=7f7ffaca&"
import script from "./SoftVersionImage.vue?vue&type=script&lang=js&"
export * from "./SoftVersionImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f7ffaca')) {
      api.createRecord('7f7ffaca', component.options)
    } else {
      api.reload('7f7ffaca', component.options)
    }
    module.hot.accept("./SoftVersionImage.vue?vue&type=template&id=7f7ffaca&", function () {
      api.rerender('7f7ffaca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/SoftVersionIcon/components/common/SoftVersionImage.vue"
export default component.exports